import React from "react";

export default function DemoControls({ running, started, step, total, completed, timeSaved, regCount, onRun, onBack, onNext, onReset }) {
  return (
    <>
      <div className="lcx-controls">
        <button type="button" className="lcx-btn primary" onClick={onRun} disabled={running}>▶ Run Demo</button>
        <button type="button" className="lcx-btn outline" onClick={onBack} disabled={!started || step === 0}>← Back</button>
        <button type="button" className="lcx-btn outline" onClick={onNext} disabled={!started || step === total - 1}>Next →</button>
        <button type="button" className="lcx-btn ghost" onClick={onReset}>↺ Reset</button>
      </div>

      <div className="lcx-metrics">
        <div className="lcx-metric">
          <div className="v">{started ? `${step + 1}/${total}` : "—"}</div>
          <div className="l">Current Step</div>
        </div>
        <div className="lcx-metric">
          <div className="v">{completed ? "✅" : running ? "▶" : "—"}</div>
          <div className="l">Status</div>
        </div>
        <div className={`lcx-metric ${completed ? "active" : ""}`}>
          <div className="v">{completed ? timeSaved : "…"}</div>
          <div className="l">Time Saved</div>
        </div>
        <div className="lcx-metric">
          <div className="v">{regCount}</div>
          <div className="l">Regulations</div>
        </div>
      </div>
    </>
  );
}